<!-- 
Dialog showing a chart of errors over the last week.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog md">
    <errors-over-last-week-chart v-if="show" @click="hide">
      <v-card-actions>
        <v-spacer/>
        <v-btn flat @click.prevent="hide">Close</v-btn>
      </v-card-actions>
    </errors-over-last-week-chart>
  </v-dialog>
</template>

<script>
import ErrorsOverLastWeekChart from "@/components/exception-logs/ErrorsOverLastWeekChart.vue";

export default {
  components: {
    ErrorsOverLastWeekChart
  },
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
